import React, { useState, useRef, useEffect } from 'react'
import SbEditable from 'storyblok-react'
import Headline from '../atoms/Headline'
import Link from '../atoms/Link'

import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Image from '../atoms/Image'

gsap.registerPlugin(ScrollTrigger)

const HeroVideoBlock = ({ block }) => {
  const refHeroVideoScroll = useRef(null)

  useEffect(() => {
    gsap.from(refHeroVideoScroll.current, {
      //duration: 1,
      ease: 'power1.out',
      scrollTrigger: {
        trigger: refHeroVideoScroll.current,
        toggleActions: 'play none none none',
        start: 'top -40px',
        end: 99999,
        toggleClass: 'scrolled-state',
      },
    })
  }, [])

  let hasOverlayContent = false

  if (
    block.headline?.length > 0 ||
    block.subheadline?.length > 0 ||
    block.link_text?.length > 0
  ) {
    hasOverlayContent = true
  }

  return (
    <SbEditable content={block}>
      <section
        ref={refHeroVideoScroll}
        className={`hero-video-block ${hasOverlayContent ? 'has-content' : ''}`}
      >
        <div className="hero-video-block-video">
          <video
            className="vid-fluid"
            src={block.video.filename}
            autoPlay={true}
            loop={true}
            muted={true}
          />
          <div className="hero-video-block-video-gradient"></div>
        </div>
        {hasOverlayContent && (
          <div className="hero-video-block-content-overlay">
            <div className="hero-video-block-content-overlay-container">
              <div className="hero-video-block-content-overlay-content">
                {block?.headline?.length > 0 && (
                  <Headline
                    headline={block.headline}
                    headline_level="h1"
                    tagName="h1"
                  />
                )}
                {block?.subheadline?.length > 0 && <p>{block.subheadline}</p>}
                {block.link_text?.length > 0 && (
                  <Link className="btn" link={block.link}>
                    {block.link_text}
                  </Link>
                )}
              </div>
              {block.logo?.filename?.length > 0 && (
                <div className="hero-video-block-content-overlay-logo">
                  <Image image={block.logo} />
                </div>
              )}
            </div>
          </div>
        )}
      </section>
    </SbEditable>
  )
}

export default HeroVideoBlock
